import { Descriptions } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { DATE_UTIL } from "../../../../../utils/dateUtils";
import UTIL from "../../../../../utils/utils";
import { quarters } from "../../select-period";

interface Props {
    data: any,
    loading?: boolean;
}

const Information = (props: Props) => {

    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="rapm-report-details-wrapper">
            <Descriptions layout="vertical" column={4} colon={false} >

                <Descriptions.Item label={t("RapmReport.lbReportName")}>{`Scenario Report - ${data?.fiscalYear} - ${quarters.find(x => x.value === data?.quarter)?.text}`}</Descriptions.Item>


                <Descriptions.Item label={t("RapmReport.lbFiscalYear")}>{props.data?.fiscalYear}</Descriptions.Item>

                <Descriptions.Item label={t("RapmReport.lbQuarter")}>Quarter {props.data?.quarter}</Descriptions.Item>
                <Descriptions.Item label={t("RapmReport.lbReportDate")}>
                    {DATE_UTIL.convertServerToViewFormat(props.data?.created_on)}
                </Descriptions.Item>
                <Descriptions.Item label={t("RapmReport.lbReportOwner")}>{props.data?.created_by}</Descriptions.Item>
                <Descriptions.Item label={t("RapmReport.lbStatus")}>{UTIL.getLossStatesDOM(props.data?.submit_state).text}</Descriptions.Item>
            </Descriptions>
        </div >
    )
}

export default Information;